import {requests} from '../../utils';
import { BASE_URL } from '../../utils/endpoints';

const publicUrl = 'public';

export const PublicService = {
    getCampaign: (uuid: string) => requests.get(`${BASE_URL}${publicUrl}/campaign/${uuid}`),
};